/* eslint-disable no-unused-vars */
import "./App.css";
import React, { Component } from 'react'
import { Helmet } from 'react-helmet'
import { RouteOptions } from "./components/routes";

class App extends Component {
  render() {
    return (
      <>
        <Helmet>
          <meta httpEquiv="Pragma" content="no-cache" />
          <meta httpEquiv="Expires" content="0" />
        </Helmet>
        <RouteOptions />
      </>
    )
  }
} 

export default App
